import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Footer, Nav } from "@/components/Chrome";
import Home from "@/pages/Home";
import Subsite from "@/pages/Subsite";
import AppsShowcase from "@/pages/AppsShowcase";
import AppDetail from "@/pages/AppDetail";
import CaseStudies from "@/pages/CaseStudies";
import Community from "@/pages/Community";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Chrome() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <div className="grain min-h-screen bg-ink text-foreground">
      <ScrollToTop />
      {!isAdmin && <Nav />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/apps" element={<AppsShowcase />} />
          <Route path="/apps/:id" element={<AppDetail />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/pwa-apps" element={<Subsite slug="pwa-apps" />} />
          <Route path="/education" element={<Subsite slug="education" />} />
          <Route path="/consultancy" element={<Subsite slug="consultancy" />} />
          <Route path="/app-dev" element={<Subsite slug="app-dev" />} />
          <Route path="/community" element={<Community />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
    </div>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Chrome />
          <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#333333", border: "1px solid rgba(155,31,110,0.45)", color: "#EDEDED" } }} />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
